// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"4HPaj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _1Jpg = require("url:../fotos/gallery/1.jpg");
var _1JpgDefault = parcelHelpers.interopDefault(_1Jpg);
var _2Jpg = require("url:../fotos/gallery/2.jpg");
var _2JpgDefault = parcelHelpers.interopDefault(_2Jpg);
var _3Jpg = require("url:../fotos/gallery/3.jpg");
var _3JpgDefault = parcelHelpers.interopDefault(_3Jpg);
var _4Jpg = require("url:../fotos/gallery/4.jpg");
var _4JpgDefault = parcelHelpers.interopDefault(_4Jpg);
var _5Jpg = require("url:../fotos/gallery/5.jpg");
var _5JpgDefault = parcelHelpers.interopDefault(_5Jpg);
var _6Jpg = require("url:../fotos/gallery/6.jpg");
var _6JpgDefault = parcelHelpers.interopDefault(_6Jpg);
var _7Jpg = require("url:../fotos/gallery/7.jpg");
var _7JpgDefault = parcelHelpers.interopDefault(_7Jpg);
var _8Jpg = require("url:../fotos/gallery/8.jpg");
var _8JpgDefault = parcelHelpers.interopDefault(_8Jpg);
var _9Jpg = require("url:../fotos/gallery/9.jpg");
var _9JpgDefault = parcelHelpers.interopDefault(_9Jpg);
const CONFIG = {
    // ── Fechas y lugar ──────────────────────────────────────────
    // Formato ISO: 'YYYY-MM-DDTHH:MM:SS'
    weddingDate: "2026-10-24T15:00:00",
    // ── Colores del degradado de fondo (deben coincidir con el CSS) ──
    // Se interpolan en scroll entre secciones claras y oscuras.
    gradientLight: [
        250,
        247,
        242
    ],
    gradientDark: [
        44,
        36,
        25
    ],
    // ── Secciones y si su fondo dominante es claro u oscuro ──────
    gradientSections: [
        {
            id: "hero",
            light: false
        },
        {
            id: "personal-card",
            light: false
        },
        {
            id: "countdown",
            light: false
        },
        {
            id: "gallery",
            light: true
        },
        {
            id: "dresscode",
            light: false
        },
        {
            id: "itinerary",
            light: true
        },
        {
            id: "notices",
            light: true
        },
        {
            id: "location",
            light: false
        },
        {
            id: "rsvp",
            light: true
        }
    ],
    galleryPhotos: [
        {
            src: (0, _1JpgDefault.default),
            caption: ""
        },
        {
            src: (0, _2JpgDefault.default),
            caption: ""
        },
        {
            src: (0, _3JpgDefault.default),
            caption: ""
        },
        {
            src: (0, _4JpgDefault.default),
            caption: ""
        },
        {
            src: (0, _5JpgDefault.default),
            caption: ""
        },
        {
            src: (0, _6JpgDefault.default),
            caption: ""
        },
        {
            src: (0, _7JpgDefault.default),
            caption: ""
        },
        {
            src: (0, _8JpgDefault.default),
            caption: ""
        },
        {
            src: (0, _9JpgDefault.default),
            caption: ""
        }
    ],
    // ── Testing Mode? ───────────────────────────────────────────────
    // Sirve para visualizar lo que veria un invitado al entrar a la pagina
    testingMode: false
};
window.CONFIG = CONFIG;

},{"url:../fotos/gallery/1.jpg":"iHPXy","url:../fotos/gallery/2.jpg":"fhK7l","url:../fotos/gallery/3.jpg":"erA84","url:../fotos/gallery/4.jpg":"1NCR8","url:../fotos/gallery/5.jpg":"hGhNV","url:../fotos/gallery/6.jpg":"d8sFF","url:../fotos/gallery/7.jpg":"l9aOI","url:../fotos/gallery/8.jpg":"60EbG","url:../fotos/gallery/9.jpg":"8p8t9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iHPXy":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8D5Vz");

},{}],"fhK7l":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fFCc9");

},{}],"erA84":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3WYxB");

},{}],"1NCR8":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8D5lp");

},{}],"hGhNV":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("qKCe9");

},{}],"d8sFF":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cIo1j");

},{}],"l9aOI":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("jvYSj");

},{}],"60EbG":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2ZN2w");

},{}],"8p8t9":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7nRrR");

},{}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["4HPaj"], "4HPaj", "parcelRequire2c2c", {})

//# sourceMappingURL=public.e92cd056.js.map
